import { render } from "./ks-footer.vue?vue&type=template&id=d747a1be"
import script from "./ks-footer.vue?vue&type=script&lang=js"
export * from "./ks-footer.vue?vue&type=script&lang=js"

import "./ks-footer.vue?vue&type=style&index=0&id=d747a1be&lang=css"
script.render = render

export default script